class DesignAtomsGraphics {
  DAContainers = null;
  viewer = null;
  DAColors = null;

  oldContainer = null;
  newContainer = null;

  /**
   * @param {string} itemsColor (Optional) string value must start with: "#", "rgb( ", "rgba(", "cmyk("
   * @param {string} outputColor (Required) string value must start with: "#", "rgb( ", "rgba(", "cmyk("
   * @param {string} visualizationColor (Required) string value must start with: "#", "rgb( ", "rgba("
   */
  options = {
    // itemsColor: "cmyk(0%,0%,0%,100%,100%)",
    outputColor: "cmyk(0%,0%,0%,100%,100%)",
    visualizationColor: "#000000",
  };

  constructor(DAContainers, viewer, DAColors, documentOptions) {
    this.DAContainers = DAContainers;
    this.viewer = viewer;
    this.DAColors = DAColors;

    if (!!documentOptions) {
      this.options = documentOptions; 
    }

    this.oldContainer = this.viewer.userEditContainer; //main container
    if (this.oldContainer) {
      const oldContainerItems = this._getContainerItems(this.oldContainer);
      const oldContainerName = this.oldContainer.name ?? "";

      this.newContainer = this._createColorlessContainer(oldContainerItems, oldContainerName);
    }
  }

  _getContainerItems(container) {
    let containerItems = container.items.toArray();
    if (!!this.options?.itemsColor) {
      containerItems = this._updateContainerItemsColorSchema(containerItems);
    }
    return containerItems;
  }
  
  _updateContainerItemsColorSchema(containerItems) {
    const colorParser = this.viewer.colorParser;
    const itemsColor = this.options.itemsColor;

    function mapper(item) {
      let newItem = item;
      const itemGroup = newItem?.items;
      if (!!itemGroup) {
        const len = itemGroup?.length;
        if (len) {
          for (let i = 0; i < len; i++) {
            let _item = itemGroup.get(i);
            if (!!_item?.items) {
              _item = mapper(_item);
            } else {
              _item.color = colorParser.parse(itemsColor);
            }
          }
        }
        newItem.items = itemGroup;
      } else {
        newItem.color = colorParser.parse(itemsColor);
      }
      return newItem;
    }

    const updatedContainerItems = containerItems.map((item) => mapper(item));
    return updatedContainerItems;
  }
  
  _createColorlessContainer(oldContainerItems, oldContainerName) {
    const container = new this.DAContainers.ColorLessContainer(
      oldContainerItems,
      oldContainerName
    );
    container.printingTechniqueConstraints = this._createTechniqueConstraints();
    container.outputColor = this.viewer.colorParser.parse(this.options.outputColor);
    const visualization = new this.DAContainers.ColorContainerVisualization();
    visualization.color = this.viewer.colorParser.parse(this.options.visualizationColor);
    container.visualization = visualization;
    return container;
  }

  _createTechniqueConstraints() {
    const techniqueConstraints = new this.DAContainers.PrintingTechniqueConstraints();
    techniqueConstraints.minFontSize = 8;
    techniqueConstraints.minWidth = 100;
    techniqueConstraints.targetDpi = 300;
    techniqueConstraints.allowRasterElements = true;
    return techniqueConstraints;
  }

  _removeBackgroundContainer(surface) {
    const collection = surface.containers._collection;
    const backgroundContainer = collection.find(
      (container) => container._name === "Background"
    );
    const backgroundContainerIndex = surface.containers.indexOf(backgroundContainer);
    if (backgroundContainerIndex !== -1) {
      surface.containers.removeAt(backgroundContainerIndex);
    }
  }

  replaceContainer(oldLayer, newLayer) {
    const surface = oldLayer.parentComponent;

    if (!surface) {
      return;
    }

    const index = surface.containers.indexOf(oldLayer);
    if (index !== -1) {
      surface.containers.removeAt(index);
      surface.containers.insertAt(index, newLayer);
      this._removeBackgroundContainer(surface);
    }

    if (this.viewer.userEditContainer === oldLayer) {
      this.viewer.userEditContainer = newLayer;
    }

    this.viewer.canvas.redraw();
  }
}